export default "__VITE_ASSET__Bvu7zVYs__"